import { render, staticRenderFns } from "./DetailStudent.vue?vue&type=template&id=138c38fa&"
import script from "./DetailStudent.vue?vue&type=script&lang=js&"
export * from "./DetailStudent.vue?vue&type=script&lang=js&"
import style0 from "./DetailStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports